import { useEffect } from "react";

const SELECTOR = ".btn-wine, .btn-gold, .btn-ghost, .btn-royal, [data-ripple]";

/** Adds an ink ripple from the touch point to every primary button in the app. */
export function useRipple() {
  useEffect(() => {
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
    const onDown = (e) => {
      const el = e.target.closest?.(SELECTOR);
      if (!el || el.disabled) return;
      const r = el.getBoundingClientRect();
      const size = Math.max(r.width, r.height) * 2.2;
      const span = document.createElement("span");
      span.className = "ripple-wave";
      span.style.width = span.style.height = `${size}px`;
      span.style.left = `${e.clientX - r.left - size / 2}px`;
      span.style.top = `${e.clientY - r.top - size / 2}px`;
      if (getComputedStyle(el).position === "static") el.style.position = "relative";
      el.appendChild(span);
      setTimeout(() => span.remove(), 650);
    };
    document.addEventListener("pointerdown", onDown);
    return () => document.removeEventListener("pointerdown", onDown);
  }, []);
}
